import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const getPartnerAnalytics = createAsyncThunk('analytics/getPartner', async ({ userId, period, theaterId }) => {
  const res = await axios.get(`${API_BASE}/analytics/partner/${userId}`, { params: { period, theaterId } });
  return res.data;
});

export const getPlatformAnalytics = createAsyncThunk('analytics/getPlatform', async () => {
  const res = await axios.get(`${API_BASE}/analytics/platform`);
  return res.data;
});

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    partnerAnalytics: null,
    platformAnalytics: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPartnerAnalytics.pending, (state) => { state.loading = true; });
    builder.addCase(getPartnerAnalytics.fulfilled, (state, action) => {
      state.loading = false;
      state.partnerAnalytics = action.payload;
    });
    builder.addCase(getPartnerAnalytics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getPlatformAnalytics.fulfilled, (state, action) => {
      state.platformAnalytics = action.payload;
    });
  }
});

export default analyticsSlice.reducer;
